import script from "./EmptyContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyContent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__